/**
 * 控制骨架屏显示隐藏
 * 使用方法：
 * 容器使用 .skeleton类名。元素使用 需要骨架屏的元素类名.skeleton-item
 * 1. 在需要使用骨架屏的元素上添加 v-skeleton 指令
 * 2. 在需要显示骨架屏的时候，给指令传递一个 true 值，例如：v-skeleton="true"
 * 3. 在需要隐藏骨架屏的时候，给指令传递一个 delay 值，例如：v-skeleton:1000="false"
 */

const vSkeleton = {
  addSkeletonClass(el) {
    el.classList.add('skeleton');
  },
  removeSkeletonClass(el, delay = 300) {
    setTimeout(() => {
      el.classList.remove('skeleton');
    }, delay);
  },
  // 当指令第一次绑定到元素并且在挂载父组件之前调用
  beforeMount(el) {
    vSkeleton.addSkeletonClass(el);
  },
  beforeUpdate(el, binding) {
    if (binding.value) {
      vSkeleton.addSkeletonClass(el);
    } else {
      vSkeleton.removeSkeletonClass(el, +binding.arg);
    }
  }
};

export default vSkeleton;
